import React, { Component } from 'react'
import './avatar.scss'

class Avatar extends Component {
  getSize () {
    switch (this.props.size) {
      case 't':
        return ' size-tiny'
      case 's':
        return ' size-small'
      default:
      case 'm':
        return ' size-medium'
      case 'l':
        return ' size-large'
    }
  }

  render () {
    const { initials, status } = this.props

    let ariaClass = ''
    if (this.props.ariaText !== null && !this.props.useHtmlTitleTag) {
      ariaClass = ' hint--' + this.props.ariaPos
    }

    let titleText = null
    let ariaText = this.props.ariaText
    /*
    this.props.useHtmlTitleTag
    useHtmlTitleTag define to use html standard title tag to show on mouse over instead of aria-label
    */
    if (this.props.useHtmlTitleTag) {
      titleText = this.props.ariaText
      ariaText = null
    }

    let classNames = 'avatar' + this.getSize()
    if (this.props.disabled) classNames += ' disabled'

    return (
      <div className={classNames + ariaClass} aria-label={ariaText} title={titleText}>
        <span className='avatar__content'>{initials}</span>
        {status && <i className='avatar__status' />}
      </div>
    )
  }
}

Avatar.defaultProps = {
  initials: null,
  status: null,
  disabled: false,
  ariaText: null,
  ariaPos: 'left',
  useHtmlTitleTag: false
}

export default Avatar



// WEBPACK FOOTER //
// ./src/app/shared/elements/avatar/index.js